import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FieldConfig } from "../../../interfaces/field.interface"
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
@Component({
  selector: "app-input",
  template: `
    <ion-item [formGroup]="group">
      <div class="alinhamento-div">
        <label class="custom-label" position="stacked">
          {{ field.label ? (field.label | translate) : "" }}
          <span
            *ngIf="
              field.validations &&
              field.validations[0] &&
              field.validations[0].name == 'required'
            "
            class="danger"
            >*</span>
        </label>

        <ion-input
          placeholder="{{ field.label ? (field.label | translate) : '' }}"
          [type]="field.inputType"
          [formControlName]="field.name"
        >
        </ion-input>
      </div>
    </ion-item>

    <div class="validation-errors">
      <ng-container *ngFor="let validation of field.validations">
        <div
          class="error-message"
          *ngIf="
            validation.name == 'required' &&
            group.get(field.name) &&
            group.get(field.name)?.hasError(validation.name) &&
            (group.get(field.name)?.dirty || group.get(field.name)?.touched)
          "
        >
          {{ "Campo Obrigatório" | translate }}
        </div>

        <div
          class="error-message"
          *ngIf="
            validation.name == 'maxlength' &&
            group.get(field.name) &&
            group.get(field.name)?.hasError(validation.name) &&
            (group.get(field.name)?.dirty || group.get(field.name)?.touched)
          "
        >
          {{ "Campo deve conter no máximo" | translate }} {{ field.tamanho }}
          {{ "caracteres" }}
        </div>

        <div
          class="error-message"
          *ngIf="
            validation.name == 'email' &&
            group.get(field.name)?.value &&
            group.get(field.name)?.hasError(validation.name) &&
            group.get(field.name)?.touched
          "
        >
          {{ "E-mail Inválido" | translate }}
        </div>

        <div
          class="error-message"
          *ngIf="
            validation.name == 'minlength' &&
            group.get(field.name) &&
            group.get(field.name)?.hasError(validation.name) &&
            (group.get(field.name)?.dirty || group.get(field.name)?.touched)
          "
        >
          {{ "A senha deve conter no mínimo 6 caracteres" | translate }}
        </div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      ion-input {
        font-size: 14px;
        color: #787486;
        min-height: 25px !important;
        padding: 0 !important;
      }

      .alinhamento-div {
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .custom-label {
        font-size: 15px;
        font-weight: 500;
      }

      ion-item {
        --inner-border-width: 0;
        padding: 10px 0;
        margin: 0 20px;
      }

      .error-message {
        padding-bottom: 10px !important;
        font-size: 12px !important;
      }

      .validation-errors {
        margin-left: 35px;
      }
    `,
  ],
  standalone: true,
  imports: [
    TranslateModule,
    IonicModule,
    ReactiveFormsModule,
    CommonModule
  ]
})
export class InputComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() {}
  ngOnInit() {}
}
